module.exports = __webpack_public_path__ + "resources/img/img_blue_prism1_en.80f3a957f7fd5d023a4b821be0da2ccb.png";